


















import ActiveForm, {ActiveFormOptionsStep} from './BZCore/ActiveForm'

export default {
  name: 'FormFooter',
  props: {
    activeForm: Object as () => ActiveForm,
    submitText: {
      type: String as () => string
    },
    step: {
      type: Number as () => number,
      default: 0
    },
    steps: {
      type: Array as () => ActiveFormOptionsStep[],
      default: 0
    }
  }
}
